import{createStyles as t}from"../../theme/utils/create-styles.js";var e=t({root:{height:27,"& .ant-input-number-input-wrap, .ant-input-number-input":{height:"100%"}}});export{e as styles};
